import "./BillSummary.css";

function BillSummary({

  subtotal,

  deliveryFee,

  platformFee,

  packingFee,

  gst,

  grandTotal,

  coupon = null

}) {

  const discount =
    Number(coupon?.discount) || 0;


  return (

    <section className="bill-summary-section">

      {/* =================================================
          HEADER
      ================================================= */}

      <div className="bill-section-header">

        <div className="bill-section-title">

          <div className="bill-section-icon">

            🧾

          </div>

          <div>

            <h2>

              Bill Summary

            </h2>

            <p>

              Review your payment details before placing your order.

            </p>

          </div>

        </div>

      </div>


      {/* =================================================
          COUPON
      ================================================= */}

      <button
        type="button"
        className="coupon-box"
      >

        <div className="coupon-left">

          <div className="coupon-icon">

            🏷

          </div>

          <div className="coupon-text">

            <div className="coupon-title">

              Apply Coupon

            </div>

            <div className="coupon-subtitle">

              Save more on your order.

            </div>

          </div>

        </div>


        <div className="apply-text">

          Apply →

        </div>

      </button>


      {/* =================================================
          BILL CARD
      ================================================= */}

      <div className="bill-card">

        {/* ITEM TOTAL */}

        <div className="bill-row">

          <div className="bill-label">

            Item Total

          </div>

          <div className="bill-value">

            ₹{Number(subtotal || 0).toFixed(2)}

          </div>

        </div>


        {/* PACKING FEE */}

        <div className="bill-row">

          <div className="bill-label">

            Packing Fee

          </div>

          <div className="bill-value">

            ₹{Number(packingFee || 0).toFixed(2)}

          </div>

        </div>


        {/* DELIVERY */}

        <div className="bill-row">

          <div className="bill-label">

            Delivery Fee

          </div>

          <div
            className={
              Number(deliveryFee) === 0
                ? "bill-value free-delivery"
                : "bill-value"
            }
          >

            {

              Number(deliveryFee) === 0

                ? "FREE"

                : `₹${Number(
                    deliveryFee || 0
                  ).toFixed(2)}`

            }

          </div>

        </div>


        {/* PLATFORM */}

        <div className="bill-row">

          <div className="bill-label">

            Platform Fee

          </div>

          <div className="bill-value">

            ₹{Number(platformFee || 0).toFixed(2)}

          </div>

        </div>


        {/* GST */}

        <div className="bill-row tax-row">

          <div className="bill-label">

            GST (5%)

          </div>

          <div className="bill-value">

            ₹{Number(gst || 0).toFixed(2)}

          </div>

        </div>


        {/* DISCOUNT */}

        {discount > 0 && (

          <div className="bill-row discount-row">

            <div className="bill-label">

              Coupon Discount

            </div>

            <div className="bill-value">

              - ₹{discount.toFixed(2)}

            </div>

          </div>

        )}


        {/* =================================================
            GRAND TOTAL
        ================================================= */}

        <div className="grand-total">

          <div className="total-left">

            <div className="total-title">

              Grand Total

            </div>

            <div className="total-subtitle">

              Inclusive of all taxes

            </div>

          </div>


          <div className="total-price">

            ₹{Number(grandTotal || 0).toFixed(2)}

          </div>

        </div>

      </div>


      {/* =================================================
          SAVINGS
      ================================================= */}

      {(discount > 0 ||
        Number(deliveryFee) === 0) && (

        <div className="savings-banner">

          <div className="savings-icon">

            🎉

          </div>

          <div className="savings-content">

            <div className="savings-title">

              You're Saving Money!

            </div>

            <div className="savings-desc">

              {

                discount > 0

                  ? `You saved ₹${discount.toFixed(
                      2
                    )} with your coupon.`

                  : "Congratulations! You unlocked free delivery."

              }

            </div>

          </div>

        </div>

      )}


      {/* =================================================
          DELIVERY ESTIMATE
      ================================================= */}

      <div className="delivery-estimate">

        <div className="delivery-icon">

          🚚

        </div>


        <div className="delivery-info">

          <div className="delivery-title">

            Estimated Delivery

          </div>

          <div className="delivery-time">

            30 – 45 Minutes

          </div>

          <div className="delivery-note">

            Freshly prepared and delivered hot to your doorstep.

          </div>

        </div>

      </div>

    </section>

  );

}


export default BillSummary;